module.exports = __webpack_public_path__ + "img/ecoPartner_all-win.4ee5e9f1.png";